import { FEATURE_BLOCKS } from '@/config/features';
import { CategoryMenu } from '@/components/common/CategoryMenu';

const BUSINESS_IDS = ['deposit-orders', 'acceptance', 'showroom', 'stock', 'bizcard'];
const items = FEATURE_BLOCKS.filter((b) => BUSINESS_IDS.includes(b.id));

export function BusinessCategoryPage() {
  return <CategoryMenu title="業務管理" description="業務相關功能" items={items} />;
}
